// ============================================
// ORDERS WIDGET CARD - Alpine.js component
// ============================================

import Alpine from 'alpinejs';
import { initOrdersChart } from '../charts/orders-chart';

export function registerOrdersWidgetCard() {
    Alpine.data('ordersChartCard', () => ({
        loading: true,
        error: false,
        totalOrders: 0,
        currentMonthOrders: 0,
        percentageChange: 0,

        async init() {
            try {
                const data = await this.fetchData();

                if (!data || !data.chartData) {
                    throw new Error('Invalid response data');
                }

                this.totalOrders = data.totalOrders || 0;
                this.currentMonthOrders = data.currentMonthOrders || 0;
                this.percentageChange = data.percentageChange || 0;

                this.loading = false;

                // Wait for DOM update, then init chart
                await this.$nextTick();

                if (data.chartData && data.chartData.labels && data.chartData.data) {
                    await initOrdersChart(data.chartData);
                } else {
                    throw new Error('Invalid chart data structure');
                }

            } catch (error) {
                this.error = true;
                this.loading = false;
            }
        },

        async fetchData() {
            const formData = new FormData();
            formData.append('action', 'get_orders_chart');

            const response = await fetch('/wp-admin/admin-ajax.php', {
                method: 'POST',
                body: formData,
                credentials: 'same-origin'
            });

            if (!response.ok) {
                throw new Error('Failed to fetch orders data');
            }

            const result = await response.json();

            if (!result.success) {
                throw new Error(result.data?.message || 'Failed to fetch orders data');
            }

            return result.data;
        }
    }));
}
